var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServiceUsage01 = function SvgServiceUsage01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "service_usage-01_svg2__a",
    x1: 5.57,
    x2: 133.18,
    y1: 138.46,
    y2: 10.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#service_usage-01_svg2__a",
    id: "service_usage-01_svg2__b",
    x1: 61.54,
    x2: 189.16,
    y1: 194.44,
    y2: 66.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#service_usage-01_svg2__a",
    id: "service_usage-01_svg2__c",
    x1: 33.55,
    x2: 161.16,
    y1: 166.44,
    y2: 38.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#service_usage-01_svg2__a",
    id: "service_usage-01_svg2__d",
    x1: 33.56,
    x2: 161.17,
    y1: 166.45,
    y2: 38.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#service_usage-01_svg2__a",
    id: "service_usage-01_svg2__e",
    x1: 6.97,
    x2: 134.59,
    y1: 139.87,
    y2: 12.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#service_usage-01_svg2__a",
    id: "service_usage-01_svg2__f",
    x1: 60.25,
    x2: 187.87,
    y1: 193.15,
    y2: 65.54
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M27.32 156.7c-12.59-16.14-19.51-36.16-19.51-56.69 0-50.84 41.36-92.2 92.19-92.2 6.18 0 12.36.61 18.36 1.83a3.9 3.9 0 0 0 4.6-3.06 3.9 3.9 0 0 0-3.06-4.6C113.39.67 106.7 0 100 0 86.5 0 73.41 2.64 61.07 7.86c-11.91 5.04-22.6 12.25-31.78 21.43S12.9 49.17 7.86 61.07C2.64 73.41 0 86.5 0 100c0 11.79 2.03 23.33 6.04 34.31 3.65 9.99 8.87 19.28 15.49 27.65-1.8 2.68-2.76 5.82-2.76 9.12 0 4.38 1.71 8.5 4.81 11.6s7.22 4.81 11.6 4.81 8.5-1.71 11.6-4.81 4.81-7.22 4.81-11.6-1.71-8.5-4.81-11.6c-5.26-5.26-13.23-6.18-19.46-2.79Zm13.93 20.45c-1.62 1.62-3.78 2.52-6.08 2.52s-4.45-.89-6.08-2.52-2.52-3.78-2.52-6.08.89-4.45 2.52-6.08c1.68-1.68 3.88-2.51 6.08-2.51s4.4.84 6.08 2.51c1.62 1.62 2.52 3.78 2.52 6.08s-.89 4.45-2.52 6.08",
    style: {
      fill: "url(#service_usage-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.96 65.67v.02c-3.65-9.99-8.87-19.28-15.49-27.65 1.8-2.68 2.76-5.82 2.76-9.12 0-4.38-1.71-8.5-4.81-11.6s-7.22-4.81-11.6-4.81-8.5 1.71-11.6 4.81-4.81 7.22-4.81 11.6 1.71 8.5 4.81 11.6 7.22 4.81 11.6 4.81c2.79 0 5.48-.7 7.86-2.01 12.58 16.13 19.5 36.15 19.5 56.67 0 50.83-41.36 92.19-92.19 92.19-6.12 0-12.24-.6-18.18-1.79-2.12-.42-4.17.95-4.6 3.06-.42 2.12.95 4.17 3.06 4.6 6.45 1.29 13.08 1.94 19.72 1.94 13.5 0 26.59-2.64 38.93-7.86 11.91-5.04 22.6-12.25 31.79-21.43 9.18-9.18 16.39-19.88 21.43-31.79 5.22-12.33 7.86-25.43 7.86-38.93 0-11.79-2.03-23.33-6.04-34.31M170.91 35c-1.62 1.62-3.78 2.52-6.08 2.52s-4.45-.89-6.08-2.52c-1.62-1.62-2.52-3.78-2.52-6.08s.89-4.45 2.52-6.08 3.78-2.52 6.08-2.52 4.45.89 6.08 2.52c1.62 1.62 2.52 3.78 2.52 6.08s-.89 4.45-2.52 6.08",
    style: {
      fill: "url(#service_usage-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.82 167.18.06.02a3.91 3.91 0 0 0 3.91 3.91h24.42a3.91 3.91 0 0 0 3.91-3.91v-7.57a60.9 60.9 0 0 0 14.66-6.08l5.35 5.35c.73.73 1.73 1.14 2.76 1.14s2.03-.41 2.76-1.15l17.26-17.28c1.52-1.53 1.52-4 0-5.52l-5.34-5.34a61.3 61.3 0 0 0 6.08-14.66h7.54a3.91 3.91 0 0 0 3.91-3.91V87.76a3.91 3.91 0 0 0-3.91-3.91h-7.55a60.9 60.9 0 0 0-6.08-14.66l5.31-5.31c.73-.73 1.14-1.73 1.14-2.76s-.41-2.03-1.15-2.76L141.58 41.1c-1.53-1.52-4-1.52-5.52 0l-5.31 5.31a60.8 60.8 0 0 0-14.66-6.07v-7.5a3.91 3.91 0 0 0-3.91-3.91H87.76a3.91 3.91 0 0 0-3.91 3.91v7.5a61.2 61.2 0 0 0-14.66 6.07l-5.31-5.31c-1.53-1.53-4-1.53-5.52 0L41.08 58.36c-.73.73-1.14 1.73-1.15 2.76 0 1.04.41 2.03 1.14 2.76l5.31 5.31a61.3 61.3 0 0 0-6.08 14.66h-7.53c-2.16 0-3.91 1.75-3.91 3.9v24.42c-.01 1.04.4 2.03 1.13 2.76s1.73 1.14 2.76 1.14h7.54a60.9 60.9 0 0 0 6.08 14.66l-5.34 5.34c-1.53 1.52-1.53 4 0 5.52l17.26 17.28c.73.73 1.73 1.15 2.76 1.15s2.03-.41 2.76-1.14l5.35-5.35a61.3 61.3 0 0 0 14.66 6.08zm-13.07-21.85c-1.55-1-3.58-.78-4.88.52l-4.76 4.76-11.74-11.75 4.75-4.75c1.3-1.3 1.52-3.34.52-4.88a53.6 53.6 0 0 1-7.4-17.86 3.915 3.915 0 0 0-3.82-3.09h-6.71V91.67h6.71c1.84 0 3.43-1.29 3.82-3.09a53.6 53.6 0 0 1 7.4-17.86c1-1.55.78-3.58-.52-4.88l-4.72-4.72 11.75-11.74 4.72 4.72c1.3 1.3 3.34 1.52 4.88.52a53.6 53.6 0 0 1 17.86-7.4c1.8-.39 3.09-1.98 3.09-3.82v-6.67h16.61v6.67c0 1.84 1.29 3.43 3.09 3.82a53.6 53.6 0 0 1 17.86 7.4c1.55 1 3.58.78 4.88-.52l4.72-4.72 11.75 11.74-4.72 4.72a3.905 3.905 0 0 0-.52 4.88 53.6 53.6 0 0 1 7.4 17.86c.39 1.8 1.98 3.09 3.82 3.09h6.71v16.61h-6.71c-1.84 0-3.43 1.29-3.82 3.09a53.6 53.6 0 0 1-7.4 17.86c-1 1.55-.78 3.58.52 4.88l4.75 4.75-11.74 11.75-4.76-4.76a3.905 3.905 0 0 0-4.88-.52 53.6 53.6 0 0 1-17.86 7.4c-1.8.39-3.09 1.98-3.09 3.82v6.74H91.7v-6.74c0-1.84-1.29-3.43-3.09-3.82a53.6 53.6 0 0 1-17.86-7.4",
    style: {
      fill: "url(#service_usage-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28 100c0-17.8-14.48-32.28-32.28-32.28S67.72 82.2 67.72 100 82.2 132.28 100 132.28s32.28-14.48 32.28-32.28m-56.74 0c0-13.49 10.97-24.46 24.46-24.46s24.46 10.97 24.46 24.46-10.97 24.46-24.46 24.46S75.54 113.48 75.54 100",
    style: {
      fill: "url(#service_usage-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.14 11.63c.05.25.13.5.22.73.1.23.22.46.36.67.07.11.15.21.23.31s.17.2.26.29.18.18.28.26.2.16.31.23c.21.14.44.26.67.36.24.1.48.17.73.22l.38.06c.13.01.26.02.38.02s.26 0 .39-.02c.13-.01.25-.03.38-.06.25-.05.49-.13.73-.22.24-.1.46-.22.67-.36.11-.07.21-.15.31-.23s.19-.17.28-.26.18-.19.26-.29.16-.2.23-.31c.14-.21.26-.44.36-.67.1-.24.17-.48.22-.73.02-.12.04-.25.06-.38 0-.13.02-.26.02-.38s0-.26-.02-.38c0-.13-.03-.25-.06-.38-.05-.25-.13-.5-.22-.73-.1-.24-.22-.46-.36-.67-.07-.11-.15-.21-.23-.31s-.17-.19-.26-.28-.18-.18-.28-.26-.2-.16-.31-.23c-.21-.14-.44-.26-.67-.36s-.48-.17-.73-.22l-.38-.06c-.26-.03-.52-.03-.77 0a4.405 4.405 0 0 0-1.11.28c-.23.1-.46.22-.67.36-.11.07-.21.15-.31.23s-.2.17-.28.26c-.09.09-.18.18-.26.28s-.16.2-.23.31c-.14.21-.26.44-.36.67s-.17.48-.22.73l-.06.38c0 .13-.02.25-.02.38s0 .25.02.38c0 .13.03.25.06.38",
    style: {
      fill: "url(#service_usage-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.03 188.45c-.05-.25-.13-.5-.22-.73-.1-.24-.22-.46-.36-.68-.07-.11-.15-.21-.23-.31s-.17-.19-.26-.28-.18-.18-.28-.26-.2-.16-.31-.23a4 4 0 0 0-1.41-.58l-.38-.06c-.25-.03-.52-.03-.77 0-.13 0-.25.03-.38.06-.25.05-.5.13-.73.22-.24.1-.46.22-.68.36-.11.07-.21.15-.31.23s-.2.17-.28.26c-.09.09-.18.18-.26.28s-.16.2-.23.31a4 4 0 0 0-.58 1.41l-.06.38c0 .13-.02.26-.02.38s0 .26.02.39c0 .13.03.25.06.38.05.25.13.49.22.73.1.24.22.46.36.68a3.6 3.6 0 0 0 .49.59c.09.09.18.18.28.26s.2.16.31.23a4 4 0 0 0 1.41.58l.38.06c.13 0 .26.02.39.02s.25 0 .38-.02c.13 0 .25-.03.38-.06.25-.05.5-.13.73-.22.24-.1.46-.22.68-.36.11-.07.21-.15.31-.23s.19-.17.28-.26.18-.18.26-.28.16-.2.23-.31a4 4 0 0 0 .58-1.41l.06-.38c.01-.13.02-.26.02-.39s0-.25-.02-.38c0-.13-.03-.25-.06-.38",
    style: {
      fill: "url(#service_usage-01_svg2__f)"
    }
  }));
};
export default SvgServiceUsage01;